import styled, { keyframes } from "styled-components";
import { theme } from "../../../constants/StyledComponents";

const fadeInSlideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const CalendarBoxContainer = styled.div`
  min-width: 260px;
  position: absolute;
  width: 100%;
  border: 1px solid ${theme.colors.black};
  border-radius: ${theme.variables.border_radius_1};
  background-color: ${theme.colors.white};
  z-index: 1000;
  margin-top: 2px;
  animation: ${fadeInSlideDown} 0.1s ease-out;
  user-select: none;
`;

export const CalendarBoxContent = styled.div`
  padding: 8px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  & .calendar-choose {
    cursor: pointer;
    & .date-selector-label-header {
      padding-right: 15px;
    }
  }
`;

export const WeekDays = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  justify-items: center;
  margin-bottom: 5px;
`;

export const Day = styled.div<{
  $isCurrentMonth: boolean;
  $isSelected: boolean;
  $isDisabled?: boolean;
}>`
  padding: 10px;
  display: flex;
  justify-content: center;
  cursor: ${({ $isCurrentMonth, $isDisabled }) =>
    $isDisabled ? "default" : $isCurrentMonth ? "pointer" : "default"};
  background-color: ${({ $isSelected, $isDisabled }) =>
    $isSelected && $isDisabled
      ? theme.colors.grey_4
      : $isSelected
        ? theme.colors.purple
        : "transparent"};
  border-radius: 4px;

  &:hover {
    background-color: ${({ $isSelected, $isCurrentMonth, $isDisabled }) =>
      $isDisabled
        ? "none"
        : $isSelected
          ? theme.colors.purple_3
          : $isCurrentMonth
            ? theme.colors.purple_2
            : "transparent"};
  }
`;

export const MonthsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
`;

export const Month = styled.div<{
  $isCurrentMonth: boolean;
  $isDisabled: boolean;
}>`
  padding: 10px;
  display: flex;
  justify-content: center;
  cursor: ${({ $isDisabled }) => ($isDisabled ? "default" : "pointer")};
  border-radius: 4px;
  background-color: ${({ $isCurrentMonth, $isDisabled }) =>
    $isCurrentMonth && $isDisabled
      ? theme.colors.grey_3
      : $isCurrentMonth
        ? theme.colors.purple
        : "transparent"};
  opacity: ${(props) => (props.$isDisabled ? 0.4 : 1)};

  &:hover {
    background-color: ${({ $isCurrentMonth, $isDisabled }) =>
      $isDisabled
        ? "none"
        : $isCurrentMonth
          ? theme.colors.purple_3
          : theme.colors.purple_2};
  }
`;

export const YearsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
`;

export const Year = styled.div<{
  $isCurrentYear: boolean;
  $isDisabled: boolean;
}>`
  padding: 10px;
  display: flex;
  justify-content: center;
  cursor: ${({ $isDisabled }) => ($isDisabled ? "default" : "pointer")};
  border-radius: 4px;
  background-color: ${({ $isCurrentYear, $isDisabled }) =>
    $isCurrentYear && $isDisabled
      ? theme.colors.grey_2
      : $isCurrentYear
        ? theme.colors.purple
        : "transparent"};
  opacity: ${(props) => (props.$isDisabled ? 0.4 : 1)};

  &:hover {
    background-color: ${({ $isCurrentYear, $isDisabled }) =>
      $isDisabled
        ? "none"
        : $isCurrentYear
          ? theme.colors.purple_3
          : theme.colors.purple_2};
  }
`;

export const CalendarInputContainer = styled.div`
  position: relative;
  user-select: none;
`;

export const InputWrapper = styled.div``;
